export default class TelematicsHelper {
    static optimizedDecimalPlaces (originalNumber, decimalPlaces = 6, base = 10) { // adapted from https://stackoverflow.com/a/29494612/999934
        var pow = Math.pow(base||10, decimalPlaces);
        return +( Math.round(originalNumber * pow) / pow ); // note the use of +()
    }
}